import { ICommand, IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { RouterHelper } from '../../global/helpers/router_helper';
import { StudentValueModel } from './../../global/components/student_value/model/student_value_model';
import { AdvisorInitRedirectStrategy } from './../../global/strategies/ap_advisor_init_redirect_strategy';
import { FeedbackSuggestedPlanModel } from './../../suggestions/components/plan_feedback/models/feedback_suggested_plan_model';

export type ReRouteAdvisorPlanAccessCommand = () => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-academic-planner')
  .service(
    'reRouteAdvisorPlanAccessCommand',
    (
      defineCommandORM: IDefineCommand,
      appConfigModel: any,
      routerHelper: RouterHelper,
      ngFeedbackSuggestedPlanModel: FeedbackSuggestedPlanModel,
      ngStudentValueModel: StudentValueModel,
      ngPreviewTermPlanConstant: ng.IServiceProvider,
      completedAutoGeneratedPreviewPlanShowingCommand: ICommand,
      dropAndCreateSuggestedPlanCommand: ICommand,
      $timeout: ng.ITimeoutService
    ) =>
      defineCommandORM('reRouteAdvisorPlanAccessCommand', (deferred) => {
        const apPlanPreviewShownKey = ngPreviewTermPlanConstant['AP_PREVIEW_AUTO_GENERATED_TERM_PLAN_SHOWN'];
        const suggestedPlan = ngFeedbackSuggestedPlanModel.read();
        // SGD-14772
        const isSuggestedPlanEmptyOrResolved =
          _4.isNull(suggestedPlan.id) || _4.isEqual(suggestedPlan.status, 'RESOLVED');
        const studentHasNoPlanSetUp =
          appConfigModel.isFeatureEnabled('academicplan-allow_autoloading_plan') &&
          !ngStudentValueModel.getBooleanValueByKey(apPlanPreviewShownKey);
        const redirectingState =
          studentHasNoPlanSetUp && isSuggestedPlanEmptyOrResolved
            ? 'ap-advisor.preview_plan.auto_generated'
            : (AdvisorInitRedirectStrategy.evaluate(ngFeedbackSuggestedPlanModel.read()) as string);
        const TIME_TO_FIX_ANGULAR_STATE_ERROR = 10;
        $timeout(() => {
          if (!routerHelper.isValidState(redirectingState)) {
            return deferred.reject();
          }

          if (!isSuggestedPlanEmptyOrResolved || !studentHasNoPlanSetUp) {
            // SGD-14772
            if (!ngStudentValueModel.getBooleanValueByKey(apPlanPreviewShownKey)) {
              completedAutoGeneratedPreviewPlanShowingCommand();
            }
            return routerHelper.navigateFromRouter(deferred, redirectingState);
          }
          // using finally as these API could throw error
          return dropAndCreateSuggestedPlanCommand().finally(() =>
            routerHelper.navigateFromRouter(deferred, redirectingState)
          );
        }, TIME_TO_FIX_ANGULAR_STATE_ERROR);
      })
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/routes/re_route_strategies/re_route_advisor_plan_access_command.ts